import React, { useEffect, useState } from "react";
import "./transactionactivity.scss";

import Table from "react-bootstrap/Table";

import { Pagination } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";
import Loader from "utils/loader";
import copy from "copy-to-clipboard";

import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";

const Transactionactivity = () => {
  // State to manage referral data, pagination, and loading
  const [show, setShow] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(10); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  // Fetch transactions from API
  const fetchUserTransactions = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(
        `${API_URL}/transactions/user-transactions`,
        {
          params: { offset, limit },
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "content-type": "application/json",
          },
        }
      );
      const data = response.data.data;
      // console.log("Transaction api response: ", response);
      console.log("Transaction activity data : ", data);
      setTransactions(data.transactions);
      setTotalItems(data.count); // Total number of items
      setTotalPages(data.pages); // Total pages from API
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserTransactions();
  }, [offset, limit]);

  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  const [copiedIndex, setCopiedIndex] = useState(null); // Store the index of the copied item

  const handleCopyToClipboard = (index, walletAddress) => {
    copy(walletAddress); // Copy the wallet address to the clipboard
    setCopiedIndex(index); // Set the index of the copied item

    // Remove the copied message after 2 seconds
    setTimeout(() => {
      setCopiedIndex(null); // Reset the copied index to null
    }, 2000);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCopy = () => {
    toast.success("Referral code copied!", {
      position: "top-center",
      autoClose: 2000,
    });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="content">
            <section className="Transactionactivity-section">
              <div className="mainparent">
                <div className="wraper">
                  <div className="leftside">
                    <div className="Products">
                      <div className="respheight">
                        <div className="tablemains">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>
                                  <p className="namesvg">
                                    Date
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>

                                <th>
                                  <p className="namesvg">Wallet Address</p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    NFT ID
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Collection Name
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Rent Per NFT
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                {/* <th><p className='namesvg'>Rent<svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                              <path d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z" fill="#D3D3D3" />
                              <path d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z" fill="black" />
                            </svg></p></th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {transactions?.length > 0 ? (
                                transactions?.map((transaction, index) => (
                                  <tr key={index}>
                                    <td>
                                      <p className="pargraphapple">
                                        {new Date(
                                          transaction.createdAt
                                        ).toLocaleDateString() || "N/A"}
                                      </p>
                                    </td>
                                    <td>
                                      <p className="pargraphapple ">
                                        <span className="elipise">
                                          {transaction?.walletAddress
                                            ? `${transaction?.walletAddress.slice(
                                                0,
                                                6
                                              )}...${transaction?.walletAddress.slice(
                                                -4
                                              )}`
                                            : ""}
                                        </span>

                                        {/* <CopyToClipboard
                                          className="blaccckkkee"
                                          text={transaction?.walletAddress}
                                          onCopy={handleCopy}
                                        > */}
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          viewBox="0 0 18 18"
                                          fill="none"
                                          className="pl-3 mx-3"
                                          onClick={() => {
                                            transaction?.walletAddress &&
                                              handleCopyToClipboard(
                                                index,
                                                transaction?.walletAddress
                                              );
                                          }}
                                        >
                                          <path
                                            opacity="0.2"
                                            d="M15.1875 2.8125V11.8125H11.8125V6.1875H6.1875V2.8125H15.1875Z"
                                            fill="#10312B"
                                          />
                                          <path
                                            d="M15.1875 2.25H6.1875C6.03832 2.25 5.89524 2.30926 5.78975 2.41475C5.68426 2.52024 5.625 2.66332 5.625 2.8125V5.625H2.8125C2.66332 5.625 2.52024 5.68426 2.41475 5.78975C2.30926 5.89524 2.25 6.03832 2.25 6.1875V15.1875C2.25 15.3367 2.30926 15.4798 2.41475 15.5852C2.52024 15.6907 2.66332 15.75 2.8125 15.75H11.8125C11.9617 15.75 12.1048 15.6907 12.2102 15.5852C12.3157 15.4798 12.375 15.3367 12.375 15.1875V12.375H15.1875C15.3367 12.375 15.4798 12.3157 15.5852 12.2102C15.6907 12.1048 15.75 11.9617 15.75 11.8125V2.8125C15.75 2.66332 15.6907 2.52024 15.5852 2.41475C15.4798 2.30926 15.3367 2.25 15.1875 2.25ZM11.25 14.625H3.375V6.75H11.25V14.625ZM14.625 11.25H12.375V6.1875C12.375 6.03832 12.3157 5.89524 12.2102 5.78975C12.1048 5.68426 11.9617 5.625 11.8125 5.625H6.75V3.375H14.625V11.25Z"
                                            fill="#10312B"
                                          />
                                        </svg>
                                        {/* </CopyToClipboard> */}
                                      </p>
                                      {copiedIndex === index && (
                                        <div
                                          className="copy-message"
                                          style={{
                                            color: "#FF8A00",
                                            marginLeft: "20px",
                                            marginBottom: "18px",
                                          }}
                                        >
                                          <span>Copied!</span>
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <p className="pargraphapple">
                                        {transaction.tokenIdStart ===
                                        transaction.tokenIdEnd
                                          ? `#${
                                              transaction.tokenIdStart || "N/A"
                                            }` // If the token IDs are the same, display only tokenIdStart
                                          : `#${
                                              transaction.tokenIdStart || "N/A"
                                            } - #${
                                              transaction.tokenIdEnd || "N/A"
                                            }`}
                                        {/* {`#${transaction.tokenIdStart}` ||
                                          "N/A"} */}
                                      </p>
                                    </td>
                                    <td>
                                      <p className="pargraphapple">
                                        {transaction?.projectDetails?.[0]
                                          ?.name || "N/A"}
                                      </p>
                                    </td>

                                    <td>
                                      <p className="pargraphapple">
                                        $
                                        {(transaction.rentPerNft / 12).toFixed(
                                          6
                                        ) || "0.00"}
                                      </p>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5">
                                    <p className="pargraphapple">
                                      No transactions found.
                                    </p>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                          <div className="paginationdiv">
                            <p>
                              {totalItems === 0
                                ? "SHOWING 0 OF 0"
                                : `SHOWING ${
                                    (offset - 1) * limit + 1
                                  }-${Math.min(
                                    offset * limit,
                                    totalItems
                                  )} OF ${totalItems}`}
                            </p>
                            <div className="numberbagidiv">
                              <Pagination>
                                <Pagination.Prev
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(Math.max(1, offset - 1));
                                  }}
                                  disabled={offset === 1 || totalItems === 0}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="rightarow"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M5 6.5L8 9.5V3.5L5 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M1.64625 6.85366L4.64625 9.85366C4.74007 9.94748 4.86732 10.0002 5 10.0002C5.13268 10.0002 5.25993 9.94748 5.35375 9.85366C5.44757 9.75984 5.50028 9.63259 5.50028 9.49991C5.50028 9.36722 5.44757 9.23998 5.35375 9.14616L2.70687 6.49991L5.35375 3.85366C5.40021 3.8072 5.43705 3.75205 5.4622 3.69135C5.48734 3.63066 5.50028 3.5656 5.50028 3.49991C5.50028 3.43421 5.48734 3.36915 5.4622 3.30846C5.43705 3.24776 5.40021 3.19261 5.35375 3.14616C5.25993 3.05234 5.13268 2.99963 5 2.99963C4.9343 2.99963 4.86925 3.01257 4.80855 3.03771C4.74786 3.06285 4.69271 3.0997 4.64625 3.14616L1.64625 6.14616C1.59976 6.19259 1.56288 6.24774 1.53772 6.30844C1.51256 6.36913 1.49961 6.4342 1.49961 6.49991C1.49961 6.56561 1.51256 6.63068 1.53772 6.69138C1.56288 6.75207 1.59976 6.80722 1.64625 6.85366ZM4.64625 6.85366L7.64625 9.85366C7.71618 9.92366 7.8053 9.97134 7.90235 9.99067C7.99939 10.01 8.09998 10.0001 8.1914 9.96222C8.28281 9.92434 8.36092 9.86019 8.41586 9.7779C8.4708 9.6956 8.50008 9.59885 8.5 9.49991V7.02303C9.8658 7.14928 11.1353 7.78068 12.0601 8.79366C12.9849 9.80665 13.4984 11.1283 13.5 12.4999C13.5 12.6325 13.5527 12.7597 13.6464 12.8535C13.7402 12.9472 13.8674 12.9999 14 12.9999C14.1326 12.9999 14.2598 12.9472 14.3536 12.8535C14.4473 12.7597 14.5 12.6325 14.5 12.4999C14.4979 10.8631 13.8793 9.28714 12.7674 8.08601C11.6554 6.88488 10.1318 6.14674 8.5 6.01866V3.49991C8.50008 3.40096 8.4708 3.30421 8.41586 3.22191C8.36092 3.13962 8.28281 3.07547 8.1914 3.03759C8.09998 2.99972 7.99939 2.98982 7.90235 3.00914C7.8053 3.02847 7.71618 3.07615 7.64625 3.14616L4.64625 6.14616C4.59976 6.19259 4.56288 6.24774 4.53772 6.30844C4.51256 6.36913 4.49961 6.4342 4.49961 6.49991C4.49961 6.56561 4.51256 6.63068 4.53772 6.69138C4.56288 6.75207 4.59976 6.80722 4.64625 6.85366ZM5.70875 6.49991L7.5 4.70678V8.29303L5.70875 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Prev>
                                {/* Pagination Items */}
                                {totalPages <= 5 ? (
                                  // Show all pages if totalPages <= 5
                                  [...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item
                                      key={i}
                                      active={i + 1 === offset}
                                      onClick={() => handlePageChange(i + 1)}
                                    >
                                      {i + 1}
                                    </Pagination.Item>
                                  ))
                                ) : (
                                  // Handle ellipsis for large number of pages
                                  <>
                                    <Pagination.Item
                                      active={offset === 1}
                                      onClick={() => handlePageChange(1)}
                                    >
                                      1
                                    </Pagination.Item>
                                    {offset > 3 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    {offset === 1 || offset === totalPages
                                      ? [...Array(3)].map((_, i) => {
                                          const page =
                                            offset === 1
                                              ? i + 1
                                              : totalPages - 3 + i + 1;
                                          return (
                                            <Pagination.Item
                                              key={page}
                                              active={page === offset}
                                              onClick={() =>
                                                handlePageChange(page)
                                              }
                                            >
                                              {page}
                                            </Pagination.Item>
                                          );
                                        })
                                      : [...Array(3)].map((_, i) => {
                                          const page = offset - 1 + i;
                                          return (
                                            <Pagination.Item
                                              key={page}
                                              active={page === offset}
                                              onClick={() =>
                                                handlePageChange(page)
                                              }
                                            >
                                              {page}
                                            </Pagination.Item>
                                          );
                                        })}
                                    {offset < totalPages - 2 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    <Pagination.Item
                                      active={offset === totalPages}
                                      onClick={() =>
                                        handlePageChange(totalPages)
                                      }
                                    >
                                      {totalPages}
                                    </Pagination.Item>
                                  </>
                                )}
                                <Pagination.Next
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(
                                        Math.min(totalPages, offset + 1)
                                      );
                                  }}
                                  disabled={
                                    offset === totalPages || totalItems === 0
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="leftti"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M11 6.5L8 9.5V3.5L11 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M14.3538 6.85366L11.3538 9.85366C11.2599 9.94748 11.1327 10.0002 11 10.0002C10.8673 10.0002 10.7401 9.94748 10.6462 9.85366C10.5524 9.75984 10.4997 9.63259 10.4997 9.49991C10.4997 9.36722 10.5524 9.23998 10.6462 9.14616L13.2931 6.49991L10.6462 3.85366C10.5998 3.8072 10.5629 3.75205 10.5378 3.69135C10.5127 3.63066 10.4997 3.5656 10.4997 3.49991C10.4997 3.43421 10.5127 3.36915 10.5378 3.30846C10.5629 3.24776 10.5998 3.19261 10.6462 3.14616C10.7401 3.05234 10.8673 2.99963 11 2.99963C11.0657 2.99963 11.1308 3.01257 11.1914 3.03771C11.2521 3.06285 11.3073 3.0997 11.3538 3.14616L14.3538 6.14616C14.4002 6.19259 14.4371 6.24774 14.4623 6.30844C14.4874 6.36913 14.5004 6.4342 14.5004 6.49991C14.5004 6.56561 14.4874 6.63068 14.4623 6.69138C14.4371 6.75207 14.4002 6.80722 14.3538 6.85366ZM11.3538 6.85366L8.35375 9.85366C8.28382 9.92366 8.1947 9.97134 8.09765 9.99067C8.00061 10.01 7.90002 10.0001 7.8086 9.96222C7.71719 9.92434 7.63908 9.86019 7.58414 9.7779C7.5292 9.6956 7.49992 9.59885 7.5 9.49991V7.02303C6.1342 7.14928 4.86467 7.78068 3.93989 8.79366C3.01511 9.80665 2.50165 11.1283 2.5 12.4999C2.5 12.6325 2.44732 12.7597 2.35355 12.8535C2.25979 12.9472 2.13261 12.9999 2 12.9999C1.86739 12.9999 1.74021 12.9472 1.64645 12.8535C1.55268 12.7597 1.5 12.6325 1.5 12.4999C1.50205 10.8631 2.12068 9.28714 3.23262 8.08601C4.34457 6.88488 5.86821 6.14674 7.5 6.01866V3.49991C7.49992 3.40096 7.5292 3.30421 7.58414 3.22191C7.63908 3.13962 7.71719 3.07547 7.8086 3.03759C7.90002 2.99972 8.00061 2.98982 8.09765 3.00914C8.1947 3.02847 8.28382 3.07615 8.35375 3.14616L11.3538 6.14616C11.4002 6.19259 11.4371 6.24774 11.4623 6.30844C11.4874 6.36913 11.5004 6.4342 11.5004 6.49991C11.5004 6.56561 11.4874 6.63068 11.4623 6.69138C11.4371 6.75207 11.4002 6.80722 11.3538 6.85366ZM10.2913 6.49991L8.5 4.70678V8.29303L10.2913 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Next>
                              </Pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <Modal
            className="ambmodalmain1"
            show={show}
            onHide={handleClose}
            centered
          >
            {/* <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header> */}
            <Modal.Body>
              <div className="modal2">
                {/* <img src='\product\tickkk.svg' className='tickkimg' alt='img' /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="213"
                  height="213"
                  viewBox="0 0 213 213"
                  fill="none"
                >
                  <path
                    d="M159.75 159.75C189.159 130.341 189.159 82.6591 159.75 53.2499C130.341 23.8407 82.6591 23.8407 53.2499 53.2499C23.8408 82.6591 23.8407 130.341 53.2499 159.75C82.6591 189.159 130.341 189.159 159.75 159.75Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M193.678 83.5901C189.64 68.1832 181.534 54.0668 170.235 42.7674C153.212 25.7444 130.578 16.3698 106.504 16.3698C82.4294 16.3698 59.7956 25.7444 42.7727 42.7674C31.4744 54.0656 23.3686 68.1814 19.3306 83.5883L16.2642 82.785C20.4442 66.8343 28.8362 52.2218 40.5318 40.5265C58.1529 22.9045 81.5829 13.1997 106.504 13.1997C131.425 13.1997 154.855 22.9045 172.476 40.5265C184.172 52.2221 192.564 66.836 196.744 82.7868L193.678 83.5901Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M200.903 81.5372C201.661 84.7393 199.678 87.9501 196.476 88.7071C193.273 89.4643 190.063 87.4814 189.306 84.2794C188.549 81.0773 190.531 77.8664 193.734 77.1095C196.936 76.3522 200.146 78.3348 200.903 81.5372Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M12.1043 81.5372C11.3471 84.7393 13.33 87.9501 16.532 88.7071C19.7344 89.4643 22.945 87.4814 23.7022 84.2794C24.4591 81.0773 22.4766 77.8664 19.2745 77.1095C16.0718 76.3522 12.8613 78.3348 12.1043 81.5372Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M106.504 199.797C81.5837 199.797 58.1536 190.092 40.5317 172.47C29.1014 161.04 20.8051 146.79 16.5388 131.258L19.595 130.418C23.7154 145.421 31.7311 159.187 42.7723 170.23C59.7961 187.252 82.4298 196.627 106.504 196.627C130.577 196.627 153.211 187.252 170.234 170.23C181.277 159.187 189.291 145.421 193.412 130.42L196.468 131.26C192.202 146.79 183.906 161.04 172.475 172.47C154.854 190.092 131.424 199.797 106.504 199.797Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M12.3886 132.553C11.5964 129.359 13.5441 126.127 16.7376 125.335C19.9312 124.543 23.1635 126.491 23.9556 129.685C24.7478 132.878 22.8004 136.11 19.6066 136.903C16.4124 137.694 13.1804 135.747 12.3886 132.553Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M200.619 132.553C201.411 129.359 199.464 126.127 196.27 125.335C193.076 124.543 189.844 126.491 189.052 129.685C188.26 132.878 190.207 136.11 193.401 136.903C196.595 137.694 199.827 135.747 200.619 132.553Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M138.177 71.3188L92.7968 116.699L74.8306 98.7325L62.341 111.222L92.7968 141.678L150.667 83.8084L138.177 71.3188Z"
                    fill="white"
                  />
                </svg>
                <h4 className="changespass">Congratulations</h4>
                <p className="approveddiv">
                  Project has been successfully created.
                </p>
              </div>
              <div className="parentbuttons">
                <button
                  className="okay"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Done
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default Transactionactivity;
